/* 🌸 Registro a la lista de correo (snippets/ps-registro.liquid). Guarda en Klaviyo con su API pública de navegador. */
(function () {
  var KLAVIYO_CUENTA = 'Vrzmtm';      // id público de la cuenta (no es secreto)
  var KLAVIYO_LISTA = 'RxYz9n';       // "Lista de email" (doble confirmación)
  var LLAVE = 'ps_registro';          // memoria en el teléfono: {estado:'cerrado'|'registrada', t:fecha}
  var DIAS_SI_CIERRA = 14;

  var raiz = document.getElementById('ps-reg');
  if (!raiz) return;

  function leer() { try { return JSON.parse(localStorage.getItem(LLAVE) || 'null'); } catch (e) { return null; } }
  function guardar(estado) { try { localStorage.setItem(LLAVE, JSON.stringify({ estado: estado, t: Date.now() })); } catch (e) {} }

  var qs = location.search || '';
  var forzar = /[?&]ps_registro=1/.test(qs);
  var vieneDeCorreo = /[?&](_kx|utm_source=klaviyo|utm_medium=email)/i.test(qs);
  var memo = leer();
  if (!forzar) {
    if (vieneDeCorreo) { guardar('registrada'); return; }
    if (memo && memo.estado === 'registrada') return;
    if (memo && memo.estado === 'cerrado' && Date.now() - memo.t < DIAS_SI_CIERRA * 864e5) return;
  }

  var abierto = false, foco = null;
  var form = raiz.querySelector('.ps-reg__form');
  var input = raiz.querySelector('#ps-reg-email');
  var error = raiz.querySelector('.ps-reg__error');
  var boton = raiz.querySelector('.ps-reg__form .ps-reg__boton');
  var evento = '';

  function abrir() {
    if (abierto) return;
    abierto = true;
    foco = document.activeElement;
    raiz.hidden = false;
    requestAnimationFrame(function () { raiz.classList.add('abierto'); });
    setTimeout(function () { if (window.matchMedia('(min-width: 681px)').matches) input.focus(); }, 350);
    document.addEventListener('keydown', teclas);
    quitarDisparadores();
  }
  function cerrar(registrada) {
    if (!abierto) return;
    raiz.classList.remove('abierto');
    setTimeout(function () { raiz.hidden = true; }, 300);
    document.removeEventListener('keydown', teclas);
    if (!registrada) guardar('cerrado');
    if (foco && foco.focus) { try { foco.focus(); } catch (e) {} }
    abierto = false;
  }
  function teclas(e) { if (e.key === 'Escape') cerrar(raiz.querySelector('[data-paso="2"]').hidden === false); }

  raiz.querySelectorAll('[data-ps-cerrar]').forEach(function (b) {
    b.addEventListener('click', function () { cerrar(raiz.querySelector('[data-paso="2"]').hidden === false); });
  });
  raiz.querySelectorAll('.ps-reg__chip').forEach(function (c) {
    c.addEventListener('click', function () {
      var ya = c.classList.contains('activo');
      raiz.querySelectorAll('.ps-reg__chip').forEach(function (x) { x.classList.remove('activo'); x.setAttribute('aria-pressed', 'false'); });
      if (!ya) { c.classList.add('activo'); c.setAttribute('aria-pressed', 'true'); evento = c.getAttribute('data-evento'); } else { evento = ''; }
    });
  });

  function mostrarError(t) { error.textContent = t; error.hidden = !t; }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { mostrarError('Escribe un correo válido, por ejemplo nombre@gmail.com'); input.focus(); return; }
    mostrarError('');
    boton.disabled = true; boton.textContent = 'Un momento…';
    var props = { origen_registro: 'Ventana de la tienda' };
    if (evento) props.evento_interes = evento;
    var cuerpo = { data: { type: 'subscription', attributes: {
      custom_source: 'Ventana de registro Pink Shop',
      profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
    }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LISTA } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_CUENTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('HTTP ' + r.status);
      guardar('registrada');
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(Object.assign({ email: email }, props)); } catch (e2) {}
      raiz.querySelector('[data-paso="1"]').hidden = true;
      raiz.querySelector('[data-paso="2"]').hidden = false;
    }).catch(function () {
      mostrarError('No pudimos registrarte en este momento. Inténtalo de nuevo en un minuto.');
    }).then(function () { boton.disabled = false; boton.textContent = 'Quiero enterarme'; });
  });

  /* cuándo aparece: a los 12 s, al bajar media página o (en compu) al ir a cerrar la pestaña */
  var t = null;
  function alBajar() {
    var h = document.documentElement;
    if ((h.scrollTop || document.body.scrollTop) > (h.scrollHeight - h.clientHeight) * 0.5) abrir();
  }
  function alSalir(e) { if (e.clientY <= 0) abrir(); }
  function quitarDisparadores() {
    clearTimeout(t);
    window.removeEventListener('scroll', alBajar);
    document.removeEventListener('mouseout', alSalir);
  }
  if (forzar) { setTimeout(abrir, 400); return; }
  t = setTimeout(abrir, 12000);
  window.addEventListener('scroll', alBajar, { passive: true });
  if (window.matchMedia('(min-width: 681px)').matches) document.addEventListener('mouseout', alSalir);
})();
